import React from 'react';
import { IconWorld, IconTrophy, IconArrowRight } from '@tabler/icons-react';

const CompetitivePlay = ({ governingBodies, tournaments, resources }) => {
  return (
    <section className="ub-competitive-section">
      <div className="ub-competitive-content">
        <div className="ub-governing-bodies">
          <div className="ub-subsection-header">
            <IconWorld size={28} color="#00d4ff" />
            <h3 className="ub-subsection-title">Governing Bodies</h3>
          </div>
          <div className="ub-bodies-grid">
            {governingBodies.map((body, index) => (
              <div key={index} className="ub-body-card">
                <h4 className="ub-body-name">{body.name}</h4>
                <p className="ub-body-description">{body.description}</p>
                <a
                  href={body.website}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="ub-body-link"
                >
                  Visit Website
                  <IconArrowRight size={16} />
                </a>
              </div>
            ))}
          </div>
        </div>

        <div className="ub-tournaments">
          <div className="ub-subsection-header">
            <IconTrophy size={28} color="#c41e3a" />
            <h3 className="ub-subsection-title">Major Tournaments & Tours</h3>
          </div>
          <div className="ub-tournaments-grid">
            {tournaments.map((tournament, index) => (
              <div key={index} className="ub-tournament-card">
                <h4 className="ub-tournament-name">{tournament.name}</h4>
                <p className="ub-tournament-description">{tournament.description}</p>
                {tournament.website && (
                  <a
                    href={tournament.website}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="ub-tournament-link"
                  >
                    Learn More
                    <IconArrowRight size={16} />
                  </a>
                )}
              </div>
            ))}
          </div>
        </div>

        {resources && resources.length > 0 && (
          <div className="ub-resources">
            <h3 className="ub-subsection-title">Find Tournaments & Events</h3>
            <div className="ub-resources-list">
              {resources.map((resource, index) => (
                <a
                  key={index}
                  href={resource.website}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="ub-resource-item"
                >
                  <span className="ub-resource-name">{resource.name}</span>
                  <IconArrowRight size={18} color="#00d4ff" />
                </a>
              ))}
            </div>
          </div>
        )}
      </div>
    </section>
  );
};

export default CompetitivePlay;
